const PRODUCTION_CREATOR_SPACE = 'https://collab.fluenceur.com';

/**
 * The creator space is the root of the collab portal. The dashboard already
 * knows that portal through the base of its collab links
 * (`VITE_COLLAB_LINK_BASE_URL`, e.g. `https://collab.fluenceur.com/c`), so the
 * space is read off it rather than configured a second time.
 */
export function creatorSpaceOrigin(collabLinkBaseUrl: string | undefined): string {
  if (!collabLinkBaseUrl) return PRODUCTION_CREATOR_SPACE;

  try {
    return new URL(collabLinkBaseUrl).origin;
  } catch {
    return PRODUCTION_CREATOR_SPACE;
  }
}

/** Where an address that belongs to a creator account is sent. */
export const creatorSpaceUrl = (): string =>
  creatorSpaceOrigin(import.meta.env.VITE_COLLAB_LINK_BASE_URL);
